import UserActions from "../actions/UserActions";
import axiosInstance from "../../config/axios";
import Paths from "../../utils/paths";
import NotificationActions from "../actions/NotificationActions";

class UserMiddlewares {
  static signup(user) {
    return async (dispatch) => {
      try {
        dispatch(UserActions.signup());

        const response = await axiosInstance.post(Paths.SIGNUP, user);
        const { user: receivedUser, token } = response.data;

        if (!receivedUser || !token) {
          throw new Error("Failed to signup, please try again!");
        }

        localStorage.setItem("xml-podcast-auth-token", token);
        dispatch(UserActions.signupSuccess(receivedUser, token));
      } catch (e) {
        dispatch(
          UserActions.signupFailure(e?.response?.data?.message || e.message)
        );
      }
    };
  }

  static login(user) {
    return async (dispatch) => {
      try {
        dispatch(UserActions.login());

        const response = await axiosInstance.post(Paths.LOGIN, user);
        const { user: receivedUser, token } = response.data;

        if (!receivedUser || !token) {
          throw new Error("Failed to login, please try again!");
        }

        localStorage.setItem("xml-podcast-auth-token", token);
        dispatch(UserActions.loginSuccess(receivedUser, token));
      } catch (e) {
        dispatch(
          UserActions.loginFailure(e?.response?.data?.message || e.message)
        );
      }
    };
  }

  static initialLogin(token) {
    return async (dispatch) => {
      try {
        dispatch(UserActions.initialLogin());

        const response = await axiosInstance.get(Paths.PROFILE, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const { user } = response.data;
        dispatch(UserActions.initialLoginSuccess(user, token));
      } catch (e) {
        dispatch(
          UserActions.initialLoginFailure(
            e?.response?.data?.message || e.message
          )
        );
      }
    };
  }

  static updateProfile(user) {
    return async (dispatch, getState) => {
      const state = getState();
      const token = state.user.token;

      try {
        dispatch(UserActions.updateProfile());

        const response = await axiosInstance.post(
          Paths.UPDATE_PROFILE,
          {
            email: user.email,
            firstname: user.firstname,
            lastname: user.lastname,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        dispatch(UserActions.updateProfileSuccess(response.data.user));
        dispatch(
          NotificationActions.addNotification(
            "Profile updated successfully",
            "success",
            "",
            ""
          )
        );
      } catch (e) {
        dispatch(
          UserActions.updateProfileFailure(
            e?.response?.data?.message || e.message
          )
        );
      }
    };
  }

  static updatePassword(newPassword, previousPassword) {
    return async (dispatch, getState) => {
      const state = getState();
      const token = state.user.token;

      try {
        dispatch(UserActions.updatePassword());

        const response = await axiosInstance.post(
          Paths.UPDATE_PASSWORD,
          {
            newPassword,
            previousPassword,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        dispatch(UserActions.updatePasswordSuccess());
        dispatch(
          NotificationActions.addNotification(
            "Password updated successfully",
            "success",
            "",
            ""
          )
        );
      } catch (e) {
        dispatch(
          UserActions.updatePasswordFailure(
            e?.response?.data?.message || e.message
          )
        );
      }
    };
  }

  static uploadImage(file) {
    return async (dispatch, getState) => {
      const state = getState();
      const token = state.user.token;

      try {
        dispatch(UserActions.uploadImage());

        const form = new FormData();
        form.append("profileImage", file);

        const response = await axiosInstance.post(Paths.UPLOAD_IMAGE, form, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const imageURL = response?.data?.user?.imageURL;
        if (imageURL) {
          dispatch(UserActions.uploadImageSuccess(imageURL));
          dispatch(
            NotificationActions.addNotification(
              "File uploaded successfully",
              "success"
            )
          );
        } else {
          throw new Error("Failed to update image");
        }
      } catch (e) {
        dispatch(
          UserActions.uploadImageFailure(
            e?.response?.data?.message || e.message
          )
        );
      }
    };
  }

  static deleteAccount() {
    return async (dispatch, getState) => {
      const state = getState();
      const token = state.user.token;

      try {
        dispatch(UserActions.deleteAccount());

        const response = await axiosInstance.delete(Paths.DELETE_ACCOUNT, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("aaaa data >>", response.data);

        dispatch(UserActions.deleteAccountSuccess());
        dispatch(UserActions.logout());
      } catch (e) {
        dispatch(
          UserActions.deleteAccountFailure(
            e?.response?.data?.message || e.message
          )
        );
      }
    };
  }

  static removeImage() {
    return async (dispatch, getState) => {
      const state = getState();
      const token = state.user.token;

      try {
        dispatch(UserActions.removeImage());

        const response = await axiosInstance.delete(Paths.REMOVE_IMAGE, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const newImageURL = response.data?.user?.imageURL;

        dispatch(UserActions.removeImageSuccess(newImageURL));
        dispatch(
          NotificationActions.addNotification(
            "Profile image removed successfully",
            "success"
          )
        );
      } catch (e) {
        dispatch(
          UserActions.removeImageFailure(
            e?.response?.data?.message || e.message
          )
        );
      }
    };
  }
}

export default UserMiddlewares;
